<template>
    <div>
        <!-- Troca de Plantão -->
        <div class="modal fade" id="plantaoTrocaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="base && agenda">
                    <div class="modal-header">
                        <h5 class="modal-title">Troca</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <h5 class="mb-0" v-if="agenda.local">{{ agenda.local }}</h5>
                            <div><b>{{ agenda.search }}</b></div>
                            <div>Responsável: {{ base.usuario.search }}</div>
                            <div>Data: {{ $util.getFormatDate(base.dt_escala) }}</div>
                        </div>

                        <!-- Edição de Troca Solicitada -->
                        <template v-if="base.movimentacao">

                            <div class="alert alert-warning">
                                <h5 class="mb-0">Trocar por...</h5>
                            </div>

                        </template>

                        <!-- Solicitação de Troca -->
                        <template v-else>

                            <div class="mb-3">
                                <az-input
                                    type="date"
                                    label="Trocar para"
                                    required
                                    :validate="validate"
                                    v-model="data"
                                    @input="opcoes = null">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <az-submit color="primary" :hide_content_while_loading="true" :disabled="!data" @click="buscar_trocar()">
                                                <i class="fas fa-sync-alt"></i>
                                            </az-submit>
                                            <button v-if="false" type="button" class="btn btn-outline-primary" :disabled="!data" @click="buscar_trocar()">
                                                <i class="fas fa-sync-alt"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>

                            <div class="alert alert-secondary mb-3" v-if="data">
                                {{ $util.getFormatDate(data, 'dddd') }}
                            </div>

                            <div class="alert alert-warning mb-3" v-if="escalado">
                                <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                                Já escalado para a data!
                            </div>

                            <div class="list-group" v-if="opcoes && opcoes.lista">
                                <button type="button" class="list-group-item list-group-item-action" 
                                    :class="opcao.selec ? 'active' : ''"
                                    v-for="(opcao, iox) in opcoes.lista" :key="iox"
                                    :disabled="escalado || opcao.usuario.id_usuario == base.usuario.id_usuario"
                                    @click="selecionar(opcao)">
                                    {{ opcao.usuario.search }}
                                </button>
                            </div>

                            <az-input 
                                type="textarea"
                                label="Observações"
                                v-model="observacao" />

                            <pre class="alert alert-warning" v-if="false">{{ opcoes }}</pre>

                            <pre class="alert alert-info" v-if="false">{{ base }}</pre>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="base.movimentacao" color="danger" @click="cancelar_movimentacao(base.movimentacao)">Remover Solicitação</az-submit>
                        <az-submit :disabled="!selecionado" @click="atualizar()" v-else>Solicitar Troca</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            usuario_destino: "",
            data: "", 
            base: "",
            validate: false, 
            opcoes: null, 
            agenda: null, 
            observacao: "", 
        }
    },

    components: { 
        AzInput,
        AzSubmit
    },

    computed: { 
        selecionado: function () { 
            if ( !this.opcoes )
                return;

            return this.opcoes.lista.find(item => item.selec); 
        },

        escalado: function () { 
            if ( !this.opcoes )
                return;

            return this.opcoes.lista.find(item => item.id_usuario == this.base.id_usuario); 
        }
    },

    methods: { 
        cancelar_movimentacao (mov) { 

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'cancelar_movimentacao',
                dados: { 
                    id_plantao_movimentacao: mov.id_plantao_movimentacao,
                    motivo: 'cancelamento',
                },
                modal: 'plantaoTrocaModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }, 
            });

        },

        selecionar (opcao) { 
            this.opcoes.lista.forEach(element => {
                element.selec = false;
            });

            opcao.selec = true;
        },

        editar (plantao, agenda) { 
            this.data = "";
            this.opcoes = null; 
            this.validate = false;
            this.observacao = ""; 
            this.base = _.cloneDeep(plantao);
            this.agenda = _.cloneDeep(agenda);

            $('#plantaoTrocaModal').modal('show');
        },

        trocar (plantao, agenda) { 
            this.data = "";
            this.opcoes = null; 
            this.validate = false;
            this.base = _.cloneDeep(plantao);
            this.agenda = _.cloneDeep(agenda);

            $('#plantaoTrocaModal').modal('show');
        },

        buscar_trocar () { 
            this.opcoes = null; 

            this.$util.load(this, { 
                service: 'plantao_escalas',
                func: 'buscar_trocas',
                parms: { 
                    id_plantao_escala: this.base.id_plantao_escala, 
                    referencia: this.data, 
                },
                loadTo: res => { 
                    this.opcoes = res;
                }
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'solicitar_troca',
                dados: { 
                    id_plantao_escala_origem: this.base.id_plantao_escala, 
                    id_plantao_escala_destino: this.selecionado.id_plantao_escala, 
                    observacao: this.observacao,
                },
                toast: true,
                modal: 'plantaoTrocaModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>